import {Pipe, PipeTransform} from '@angular/core';
import {LOCALE_ID, Inject} from '@angular/core';

@Pipe({
  name: 'date'
})
export class DatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) public locale: string) {
  }

  transform(value: string): string {
    return new Date(Date.parse(value.replace(/-/g, '/'))).toLocaleDateString(this.locale, {year: 'numeric', month: '2-digit', day: '2-digit'});
  }

}
